import { Tab, Tabs, Typography } from '@material-ui/core';
import { CotasDeFundoApiResponse, EmissaoStatus, GrupoAcesso } from 'common/genericTypes';
import Chip from 'components/chip';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import { DetalhesCaracteristicas } from './caracteristicas';
import { DetalhesCriteriosRemuneracao } from './criteriosRemuneracao';
import { DetalhesDocumentos } from './documentos';
import { DetalhesEventosFinanceiros } from 'common/detalhes/eventosFinanceiros';
import { initialCotasDeFundo } from './initialCotasDeFundo';

type ComponentParams = { cotasDeFundoId: string };
type ComponentState = { initialTab?: number; detalhes?: CotasDeFundoApiResponse };

type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const DetalhesCotasDeFundo: React.FC<Props> = (props) => {
  const { cotasDeFundoId } = props.match.params;

  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [detalhes, setDetalhes] = useState<CotasDeFundoApiResponse>(initialCotasDeFundo);
  const [loadedDetalhes, setLoadedDetalhes] = useState<Boolean>(false);

  const dispatch = useDispatch();
  const isUsuarioControlesInternos =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.ControlesInternos;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroLeitura =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroLeitura;
  const isUsuarioOperacoesLeitura =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.OperacoesLeitura;
  const isUsuarioCadastroOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const getCotasDeFundoDetalhesApi = useSelector(
    (state: RootState) => state.cotasDeFundoApi.getCotasDeFundoDetalhes
  );

  const preloadedData = props.location.state?.detalhes;

  const getDetalhes = useCallback(async () => {
    if (preloadedData) {
      setDetalhes(preloadedData);
      setLoadedDetalhes(true);
      return;
    }

    try {
      const result = await getCotasDeFundoDetalhesApi(dispatch, cotasDeFundoId, true);
      setDetalhes(result);
      setLoadedDetalhes(true);
    } catch (error) { }
  }, [dispatch, getCotasDeFundoDetalhesApi, cotasDeFundoId, preloadedData]);

  useEffect(() => {
    getDetalhes();
  }, [getDetalhes]);

  return (
    <div style={{ marginRight: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h1">
          {'Cotas de Fundo-'}
          {detalhes.codigo ?? detalhes.codigoAtivo}
        </Typography>
        {detalhes.suspenso && (
          <Chip
            size="medium"
            label="SUSPENSO"
            color="error"
            style={{
              margin: 20,
            }}
          />
        )}
        {detalhes.hasPagamentosInadimplentes && <Chip size="small" label="INADIMPLENTE" color="error" />}
      </div>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Características do Fundo" value={0} />
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesCaracteristicas caracteristicas={detalhes} />}
    </div>
  );
};

export default withRouter(DetalhesCotasDeFundo);
